// A15.19/20 in-app announcements + service banners — module-local data layer.
// REAL backend (/admin/announcements). Distinct from broadcast (push campaigns);
// these are persistent in-app notices. Public /announcements/active feeds the app.
import { api } from '@/lib/api'

export interface Announcement {
  id: number
  title: string
  body: string
  severity: string // info|warning|critical
  mandatory: boolean
  enabled: boolean
  live: boolean
  starts_at: string | null
  ends_at: string | null
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchAnnouncements = (s?: AbortSignal) =>
  api.get<{ announcements: Announcement[] }>('/admin/announcements', opt(s)).then((d) => d.announcements ?? [])
export const createAnnouncement = (body: {
  title: string
  body: string
  severity: string
  mandatory: boolean
  starts_at?: string
  ends_at?: string
}) => api.post<{ id: number }>('/admin/announcements', body)
export const toggleAnnouncement = (id: number, enabled: boolean) =>
  api.post(`/admin/announcements/${id}/toggle`, { enabled })
export const deleteAnnouncement = (id: number) => api.del(`/admin/announcements/${id}`)

// datetime-local → RFC3339 (UTC); "" → undefined (no bound).
export function toRFC3339(local: string): string | undefined {
  if (!local) return undefined
  const d = new Date(local)
  return isNaN(d.getTime()) ? undefined : d.toISOString()
}

export const SEVERITIES = [
  { key: 'info', label: 'Инфо', pill: 'bg-accent/10 text-accent' },
  { key: 'warning', label: 'Предупреждение', pill: 'bg-warning/10 text-warning' },
  { key: 'critical', label: 'Критично', pill: 'bg-danger/10 text-danger' },
] as const

export function sevMeta(key: string) {
  return SEVERITIES.find((s) => s.key === key) ?? SEVERITIES[0]
}

export const AN_STR = {
  title: 'Объявления / баннеры',
  desc: 'Внутренние уведомления в приложении (не push). Обязательные = несбрасываемые',
  create: 'Создать объявление',
  name: 'Заголовок',
  body: 'Текст',
  severity: 'Важность',
  mandatory: 'Обязательное (несбрасываемое)',
  from: 'С (опц.)',
  to: 'По (опц.)',
  live: 'Показывается',
  enabled: 'Вкл',
  add: 'Создать',
  delete: 'Удалить',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет объявлений',
  refresh: 'Обновить',
} as const
